export default __webpack_public_path__ + "static/media/projectShow_grey.9eea507e.svg";